/* eslint-disable @next/next/next-script-for-ga */
import React, { FC, PropsWithChildren } from "react";
import Head from "next/head";

interface Props {
  title?: string;
  description?: string;
  image?: string;
  noindex?: boolean;
}

export const HeadMeta: FC<PropsWithChildren<Props>> = ({
  title,
  description,
  image,
  noindex,
}) => {
  const metaTitle =
    title || "Cross-Border Processing for Banks | Payall Payment Systems";
  const metaDescription =
    description ||
    "A new Cross Border Processor offering Correspondent Banking as a Service and enabling 24x7 Instant Cross Border Payments";
  const metaImage = image || "/thumbnail.png";

  return (
    <Head>
      <link rel="icon" href="/favicon.ico" />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content="https://payall.com/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@payallps" />
      <meta name="twitter:creator" content="@payallps" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-M1B9MBTV2M"
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-M1B9MBTV2M');
        `,
        }}
      ></script>
      <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js.hs-scripts.com/4785555.js"
      > </script>
    </Head>
  );
};
